// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterAnchorButton-module--root--uIHnu","submit":"NewsletterAnchorButton-module--submit--1Fy0N","submitArrow":"NewsletterAnchorButton-module--submitArrow--mh3SH"};